export const drawerWidth = 240

export const defaultLat = -34.982
export const defaultLng = 117.347

export const defaultLatLng = [defaultLat, defaultLng]

export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN

export const MAP_STYLE = "mapbox://styles/coastalfarms/cl93hgpfb000i15labhh1mve5"

export const initialViewState = {
  latitude: defaultLat,
  longitude: defaultLng,
  zoom: 7,
}
